module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_6_ECOSISTEMICO.4c87b133.jpg";